import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import FuseDialog from '@fuse/core/FuseDialog';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import DIALOGS from 'app/constants/dialogs';
import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { TRANSLATION_KEY } from '../constants';

const TrialEndedDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(TRANSLATION_KEY);

  const onClose = useCallback(() => {
    dispatch(closeDialog());
  }, [dispatch]);

  // openDialog overwrites the single opened-dialog slot, so no explicit close is needed first
  const handleViewPricingPlans = useCallback(() => {
    dispatch(openDialog({ dialogId: DIALOGS.UPGRADE_PLAN }));
  }, [dispatch]);

  return (
    <FuseDialog
      fullWidth
      maxWidth="sm"
      dialogId={DIALOGS.TRIAL_ENDED}
      onClose={onClose}
      PaperProps={{ sx: { maxWidth: '560px', borderRadius: '16px' } }}
    >
      <Box padding="32px" display="flex" flexDirection="column" gap="24px">
        {/* ── Header ── */}
        <Box display="flex" alignItems="flex-start" gap="12px">
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: 'violet.100',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <FuseSvgIcon size={22} sx={{ color: 'secondary.main' }}>
              heroicons-outline:clock
            </FuseSvgIcon>
          </Box>

          <Box display="flex" flexDirection="column" gap="8px" flex={1}>
            <Typography variant="h5" fontWeight={700} color="accent.900" fontSize="23px" lineHeight="32px">
              {t('TRIAL_ENDED_TITLE')}
            </Typography>
            <Typography variant="body2" color="accent.500" fontSize="15px" lineHeight="20px">
              {t('TRIAL_ENDED_DESCRIPTION')}
            </Typography>
          </Box>

          <IconButton onClick={onClose} size="small" sx={{ color: 'accent.500', mt: '-8px', mr: '-8px' }}>
            <CloseOutlined sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>

        {/* ── Action ── */}
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleViewPricingPlans}
            sx={{
              borderRadius: '20px',
              textTransform: 'none',
              px: '16px',
              py: '10px',
              fontSize: '14px',
              fontWeight: 500,
            }}
          >
            {t('VIEW_PRICING_PLANS')}
          </Button>
        </Box>
      </Box>
    </FuseDialog>
  );
};

export default TrialEndedDialog;
